<template>
  <div class="dflexr-jcs hedge-container">
    <div class="dflexc-jcs app-selection-panel" >
      <ul class="btn-list">
        <li class="btn btn-hedge-app" :class="{'active-app': active_app==='dice'}"
            @click="setActiveApp('dice')">
          Dice
        </li>
        <li class="btn btn-hedge-app" :class="{'active-app': active_app==='jewels'}"
            @click="setActiveApp('jewels')">
          Jewels
        </li>
        <li class="btn btn-hedge-app" :class="{'active-app': active_app==='special_items'}"
            @click="setActiveApp('special_items')">
          Spec. Items
        </li>
        <li class="btn btn-hedge-app" :class="{'active-app': active_app==='marketplace'}"
            @click="setActiveApp('marketplace')">
          Marketplace
        </li>
        <li class="btn btn-hedge-app" :class="{'active-app': active_app==='encounter_gen'}"
            @click="setActiveApp('encounter_gen')">
          Encounter Gen
        </li>
      </ul>
      <div class="return-to-empirewargames">
        <router-link class="nav-link" to="EmpireWargames">
          Return to Empire Wargames
        </router-link>
      </div>
    </div>
    <div class="dflexc-jcs hedge-app-panel">
      <dice-roller-view v-if="active_app==='dice'"/>
      <JewelRollerView v-if="active_app==='jewels'"/>
      <SpecialItemsView v-if="active_app==='special_items'"/>
      <MarketplaceView v-if="active_app==='marketplace'"/>
      <EncounterGenView v-if="active_app==='encounter_gen'"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '../assets/styles/hedge-view';



</style>

<script setup>
import DiceRollerView from "@/views/DiceRollerView.vue"
import JewelRollerView from "@/views/JewelRollerView.vue"
import SpecialItemsView from "@/views/SpecialtemRollerView.vue"
import MarketplaceView from "@/views/MarketplaceView.vue"
import EncounterGenView from "@/views/assist/EncounterGen.vue"

import '../assets/styles/hedge-view.scss'
import {ref} from "vue";

const active_app = ref('dice')


function setActiveApp(app) {
  active_app.value = app
}
</script>
